<template>
  <div class="parent-company">
    <div class="filter">
      <el-input v-model="keyword" placeholder="公司名称/地点/联系人" @keydown.enter="loadList"></el-input>
      <el-button type="primary" @click="loadList">搜索</el-button>
    </div>
    <el-table
    :data="tableData"
    tooltip-effect="dark"
    style="width: 100%"
    highlight-current-row
    @current-change="handleCurrentChange"
    height="400px">
    <el-table-column
      width="55">
      <template slot-scope="scope">
        <input type="radio" name="company" :value="scope.row"  v-model="checkedCompany" @change="onChange">
      </template>
    </el-table-column>
    <el-table-column
      prop="companyname"
      show-overflow-tooltip
      label="公司名称">
    </el-table-column>
    <el-table-column
      prop="cityName"
      label="企业所在地">
      <template slot-scope="scope">
        <span>{{scope.row.provinceName}}{{scope.row.cityName}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="linkman"
      show-overflow-tooltip
      label="联系人">
    </el-table-column>
    <el-table-column
      prop="handset"
      label="联系电话">
    </el-table-column>
  </el-table>
    <el-pagination
      background
      layout="prev, pager, next, jumper"
      :current-page.sync="pageNum"
      :page-size="pageSize"
      @current-change="loadList"
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
import {
  parentCompany,
} from '@/service/customerInformation.js';
export default {
  data(){
    return{
      keyword:'',
      tableData:[],
      pageNum:1,
      pageSize:20,
      total:0,
      checkedCompany:null,
    }
  },
  mounted() {
    this.loadList();
  },
  methods: {
    //加载列表
    loadList(){
      let companyId=Number(this.$route.query.companyId);
      parentCompany({
        companyId:companyId,
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        keyword:this.keyword,
        rational:true,
      }).then(r=>{
        if(r.Result==1){
          this.tableData=r.Data.datas || [];
          this.total=r.Data.total;
        }
      })
    },
    //单选
    handleCurrentChange(data){
      this.checkedCompany=data;
      this.$emit('onChange',data);
    },
    //单选
    onChange(){
      this.$emit('onChange',this.checkedCompany);
    },
  },
}
</script>
<style lang="scss">
.parent-company{
  .filter{
    width: 100%;
    .el-input{
      display: inline-block;
      width: 260px;
      margin-right: 10px;
    }
  }
  .el-pagination{
    text-align: right;
    margin-top: 10px;
  }
}
</style>